import apiClient from './apiClient';
import { Gallery, GalleryDetail, Photograph } from '../types';

export const AuthApi = {
    async login(credentials: any): Promise<string> {
        const response = await apiClient.post('token/', credentials);
        return response.data?.token;
    }
};

export const AdminApi = {
    async createNewGallery(data: FormData): Promise<Gallery> {
        const response = await apiClient.post('gallery/', data, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
        return response.data;
    },

    async updateGallery(data: FormData): Promise<Gallery> {
        const response = await apiClient.put('gallery/', data, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
        return response.data;
    },

    async deleteGallery(data: any): Promise<any> {
        const response = await apiClient.delete('gallery/', { data });
        return response.data;
    },

    async uploadPhotograph(data: FormData): Promise<Photograph> {
        const response = await apiClient.post('photograph/', data, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
        return response.data;
    },

    async deletePhotograph(data: any): Promise<any> {
        const response = await apiClient.delete('photograph/', { data });
        return response.data;
    },
};

export const Api = {
    async getGalleriesList(): Promise<Gallery[]> {
        const response = await apiClient.get('gallery/list');
        return response.data;
    },

    async getGalleryContent(galleryId: string | number): Promise<GalleryDetail> {
        const response = await apiClient.get(`gallery/${galleryId}/content`);
        return response.data;
    },
};
